import { LeaveIcon } from './LeaveIcon.style';

export default LeaveIcon;
